import type { SubmissionStatusView } from '@innspel/core';

/**
 * Saksnummeret på en sak slik tjeneren sendte den (`number`, tech-decisions «Saker har
 * løpenummer per leietaker fra 10001»).
 *
 * Hvorfor en hjelper og ikke bare `sak.number`: pakken avhenger av `@innspel/core` fra npm
 * (`^0.10.0`), og typene der er eldre enn feltet. Kjernen sender svaret videre urørt, så
 * tallet FINNES ved kjøring — det er bare typen som mangler det. Når avhengigheten løftes til
 * kjernen som har feltet, erstattes kallene med `sak.number` og fila slettes.
 */
export function saksnummerAv(sak: SubmissionStatusView): number | undefined {
  const nummer = (sak as SubmissionStatusView & { number?: unknown }).number;
  return typeof nummer === 'number' ? nummer : undefined;
}
